var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'invisible': !_vm.show }},[_c('div',{staticClass:"btn btn--start",attrs:{"id":"progress"}},[_c('svg',{attrs:{"viewBox":"0 0 70 70"}},[_c('circle',{style:(_vm.progress),attrs:{"r":"30","cx":"35","cy":"35"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }